import { apis } from 'ui-common'

export default {
  getMedicalHistories: () => apis.$get('/medical-histories')
}
